export default __webpack_public_path__ + "static/media/logo.f53819de.png";